module.exports = __webpack_public_path__ + "img/zq6.bf8f59ea.png";